<template>
  <!-- 消息气泡 -->
  <van-popover
    v-model="showPopover"
    placement="bottom-end"
    get-container=".user-icon"
    class="login-popover"
    :close-on-click-outside="false"
    :class="[topArrow, isMobile ? 'mobile' : 'desktop']"
  >
    <div class="tip">
      <img :src="tipIcon" alt="tip-icon" class="tip-icon" />
      <span
        :class="hasTipArrow ? 'has-tip-arrow' : ''"
        @click="goToMessage()"
        >{{ messageToast }}</span
      >
      <van-icon
        name="arrow"
        class="tip-arrow"
        @click="toCoupon"
        v-if="hasTipArrow"
      />
    </div>
    <template #reference>
      <div class="user-icon">
        <div class="red-dot" v-if="hasNewMessage"></div>
        <slot></slot>
      </div>
    </template>
  </van-popover>
</template>

<script>
  import {
    getUserMessageCount,
    setUserMessageRead,
    getUserMessageTip,
  } from '@/api/message'
  import { game_detail_configs } from '@/config/games'
  import { mapState } from 'vuex'
  import { stringToJson } from '@/utils/tool'
  import { queryPayResult } from '@/api/order'
  import { orderCouponCheck } from '@/pages/Pay/firebase'
  import { messageToastShow, messageToastClick } from './firebase'
  import { textFormat } from '@/utils/pluralRules.js'

  export default {
    name: 'loginPopover',
    components: {},
    props: {
      page: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        showPopover: false,
        hasNewMessage: false,
        type: 'message',
        couponNum: 0,
        newMessageTitle: '',
        newMessageNum: 0,
      }
    },
    computed: {
      ...mapState(['isMobile', 'loginInfo', 'userInfo']),
      loginSuccess() {
        // 登录成功
        const { exe, status } = this.loginInfo
        return exe && status
      },
      loginError() {
        // 未登录或登录失败
        const { exe, status } = this.loginInfo
        return exe && !status
      },
      tipIcon() {
        const iconMap = {
          message: require(`@/assets/images/common/tips/message.png`),
          coupon: require(`@/assets/images/common/tips/coupon.png`),
        }
        return iconMap[this.type] || iconMap['message']
      },
      messageToast() {
        if (this.loginError) {
          return this.$t('payResult.loginTip')
        }
        if (this.loginSuccess && this.couponNum > 0) {
          return textFormat(this.$t('payResult.couponToast'), this.couponNum)
        }
        return this.newMessageTitle
      },
      topArrow() {
        // 已登录，有优惠券的时候，无顶层小箭头
        if (this.loginSuccess && this.couponNum > 0) {
          return ''
        }
        return 'top-arrow'
      },
      hasTipArrow() {
        // 已登录，有优惠券的时候，有右侧引导小箭头
        if (this.loginSuccess && this.couponNum > 0) {
          return true
        }
        return false
      },
    },
    watch: {
      hasNewMessage(val) {
        this.$emit('changeHasNewMessage', val, this.newMessageNum)
      },
      loginInfo(val) {
        const { exe, status } = val
        if (exe && status) {
          // 登录成功
          this.init()
        }
        if (exe && !status && this.page === 'pay-result') {
          // 未登录或者登录失败
          this.type = 'coupon'
          this.showPopover = true
          this.closePopover()
        }
      },
      showPopover: function (val) {
        if (val && this.type === 'message') {
          // 站内消息tip曝光埋点
          messageToastShow({
            page: this.page,
          })
        }
      },
    },
    mounted() {},
    methods: {
      toCoupon() {
        orderCouponCheck()
        this.$router_push({
          path: '/coupon',
        })
      },
      init() {
        this.showPopover = false
        this.hasNewMessage = false
        this.type = ''
        this.couponNum = 0
        // 仅首页和详情页 获取 通知消息
        if (
          ['home'].concat(game_detail_configs.games).indexOf(this.page) > -1
        ) {
          this.getMessageCountAndTitle()
        }
        // 仅支付结果页显示优惠券提示
        if (this.page === 'pay-result' && this.loginSuccess) {
          this.getPayResult()
        }
      },
      getPayResult() {
        // 登录状态获取用户是否又可用的优惠券
        const { orderNo, source } = this.$route.query
        queryPayResult({ orderNo, source }).then((response) => {
          this.type = 'coupon'
          const couponNum = response.couponNum || 0
          this.couponNum = couponNum
          if (couponNum > 0) {
            this.showPopover = true
            this.closePopover()
          }
        })
      },
      closePopover() {
        // 3秒后自动关闭
        setTimeout(() => {
          this.showPopover = false
        }, 3000)
      },
      getMessageCountAndTitle() {
        const { kicoinId } = this.userInfo || {}
        getUserMessageCount(kicoinId)
          .then((response) => {
            this.hasNewMessage = response > 0 ? true : false
            this.newMessageNum = response
          })
          .catch((e) => {
            window.console.log('getUserMessageCount error ===>', e)
          })
        //获取第一条未读消息的标题
        getUserMessageTip()
          .then((response) => {
            if (!response || response.length === 0) return
            else {
              this.newMessageTitle = this.handleToastTitle(response)
              this.type = 'message'
              this.showPopover = true
              this.closePopover()
            }
          })
          .catch((e) => {
            window.console.log('getUserMessageTip error ===>', e)
          })
      },
      //一元购新增
      handleToastTitle(res) {
        // 一元购
        if (res.messageType * 1 === 4) {
          const messageBody = stringToJson(res.messageBody) || {}
          //messageCondition; // 发奖场景 1: 一元购-中奖  2: 一元购-未中奖 3: 一元购反kgold 4: 一元购发优惠券 5：裂变活动-发奖
          const { messageCondition } = messageBody
          if ([1, 2, 3, 4].includes(+messageCondition)) {
            return this.$t('oneDollarPurchase.main_title')
          } else {
            return this.$t('fission.award_distribution_notify')
          }
        } else {
          return res.messageTitle
        }
      },
      goToMessage() {
        //只有在首页和游戏页的消息tip可以点击跳转
        if (this.type === 'message') {
          //标记消息为已读
          this.setMessageRead()
          //tip点击埋点
          messageToastClick({
            page: this.page,
          })
          this.$router_push({
            path: '/message',
          })
        }
      },
      clickPopupList(key) {
        if (key === 'message') {
          this.setMessageRead()
        }
      },
      setMessageRead() {
        // 设置消息为已读状态
        if (!this.hasNewMessage) {
          return
        }
        const { kicoinId } = this.userInfo || {}
        setUserMessageRead(kicoinId).then(() => {
          this.type = 'message'
          this.hasNewMessage = false
          this.showPopover = true
        })
      },
    },
  }
</script>
<style lang="scss" scoped src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
